export const HotkeyTwo = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.583 0C17.5745 0 20 2.42546 20 5.41699V14.583C20 17.5745 17.5745 20 14.583 20H5.41699C2.42546 20 0 17.5745 0 14.583V5.41699C0 2.42546 2.42546 0 5.41699 0H14.583ZM10.0098 6.17969C9.22987 6.17974 8.60007 6.42044 8.12012 6.90039C7.63354 7.38704 7.38655 8.0034 7.37988 8.75H9.16992C9.18326 8.39 9.26349 8.11635 9.41016 7.92969C9.55014 7.74987 9.74369 7.66016 9.99023 7.66016C10.1968 7.66021 10.3605 7.72707 10.4805 7.86035C10.6135 8.007 10.6797 8.22027 10.6797 8.5C10.6797 8.81997 10.5603 9.16675 10.3203 9.54004C10.0136 10.0334 9.55686 10.5971 8.9502 11.2305L7.25977 13H12.6104V11.5303H10.4297L11.5498 10.4902C12.2098 9.8769 12.54 9.21643 12.54 8.50977C12.54 7.84987 12.3229 7.3034 11.8896 6.87012C11.4297 6.4102 10.803 6.17969 10.0098 6.17969Z"
        fill="#E3E5FA"
      />
    </svg>
  );
};
